import Vue from 'vue'
import App from './App.vue'
import router from './router'

// 自动计算rem的大小
import 'amfe-flexible'
import '@/assets/styles/common.less'
import 'normalize.css'

Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
